import ArtifactGroupType from "../base/ArtifactGroupType";

const TragedyAndComedy = {
  id: '103',
  name: 'Tragedy And Comedy',
  icon: 'TragedyAndComedy',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 25,
  gameId: 'TragedyAndComedy'
};

export default TragedyAndComedy;
